import { EmptyState } from 'components/empty.state';
import { AssignmentIndOutlined } from '@mui/icons-material';
import React, { Fragment } from 'react';

import {TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Chip} from '@mui/material';
import { toast } from 'react-toastify';
import { LoadingBox } from 'components/loading.box';
import {useGetApplications} from "../../../../core/applications/hooks";
import {format} from "date-fns";
import {fr} from "date-fns/locale";
import {Link} from "react-router-dom";

interface Props {
    tempWorker: any;
}

const ApplicationsPartial = ({tempWorker}: Props) => {
    const {data: applications, isLoading, isError} = useGetApplications(tempWorker.id, {onError: (error) => toast.error('Une erreur est survenue')});

    if (isLoading) { return (<LoadingBox />); }
    if (isError) { return (<Typography variant='subtitle1' color='error'>Une erreur est survenue</Typography>); }
    if (applications === undefined || applications.length <= 0) { return (<EmptyState icon={<AssignmentIndOutlined />} title='Aucune candidature' description="Cet intérimaire n'a encore postulé à aucune mission." />); }

    return (
        <Fragment>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Mission</TableCell>
                            <TableCell>Type de mission</TableCell>
                            <TableCell>Source</TableCell>
                            <TableCell>Date de candidature</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {applications.map((application: any) => (
                            <TableRow key={application.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">
                                    <Link to={`/dashboard/offers/${application.offer.id}`}>
                                        {application.offer.job_title}
                                    </Link>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Chip label={application.offer.job_type} color="success" component='span'/>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Chip label={application.offer.source} color="info" component='span'/>
                                </TableCell>
                                <TableCell component="th" scope="row" align="center">
                                    {format(Date.parse(application.created_at), 'dd/MM/yy', {locale: fr})}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Fragment>
    );
};

export default ApplicationsPartial;
